import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { useConsolidatedPaymentPrefContext } from "../../Context";
import InvestmentEntityText from "../PositionInvestmentName";

/**
 * @note this does not appear to be used in the `WorkflowType.Position` workflow type. When used it is later overridden in `SelectPositionsToUpdate` component;
 *     we should likely deprecate this component unless it is used in account workflow or elsewhere.
 */
export const PositionSingleDisplay = () => {
  const { currentPosition } = useConsolidatedPaymentPrefContext();

  if (!currentPosition) {
    return null;
  }

  return (
    <>
      <Text className="stacked-sm">
        Select a payment method to be applied to this 1 position
      </Text>
      <Flex flexDirection="column">
        <InvestmentEntityText
          key={`investmentEntity-${currentPosition.investmentEntityId}`}
          investmentEntityName={currentPosition.investmentEntityName}
        />
      </Flex>
    </>
  );
};
